import { Directive, ElementRef, HostListener, Input } from '@angular/core'

@Directive({
  selector: '[mbHover]'
})
export class MbHoverDirective {

  constructor (private el: ElementRef) {
  }

  @Input('hover-class') hoverClass: any = 'hover'

  @HostListener('mouseenter') onMouseEnter () {
    this.addClass()
  }

  @HostListener('mouseleave') onMouseLeave () {
    this.removeClass()
  }

  private addClass () {
    this.el.nativeElement.classList.add(this.hoverClass)
  }

  private removeClass () {
    this.el.nativeElement.classList.remove(this.hoverClass)
  }

}
